import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GossipLibrary from "../pages/gossip/page";
import GossipDetail from "../pages/gossip/detail/page";
import Debunk from "../pages/debunk/page";
import About from "../pages/about/page";
import Faq from "../pages/faq/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/gossip",
    element: <GossipLibrary />,
  },
  {
    path: "/gossip/:id",
    element: <GossipDetail />,
  },
  {
    path: "/debunk",
    element: <Debunk />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/faq",
    element: <Faq />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;